import { Skeleton } from 'antd';
import { ContainerPage } from './styles';

const App = () => {
    return (
        <>

            <Skeleton.Input active size={'large'} block style={{ width: '100%', height: '300px' }} />

            <ContainerPage>
                <div style={{ width: '180px', marginTop: "60px " }}>
                    <Skeleton>
                        <Skeleton.Node active />
                    </Skeleton>
                </div>
                <hr style={{ color: "#CACACA", opacity: "0.6", height: "1px", marginTop: "20px", marginBottom: "20px" }} />


                <Skeleton paragraph={{ rows: 5 }} active>
                </Skeleton>

                <Skeleton.Avatar shape='circle' size={'large'} style={{ width: '200px', height: '200px', position: "relative", top: "-590px", left: "-20px", border: "6px solid white" }} active />

            </ContainerPage>



        </>
    );
};

export default App;
